/**
 * デバイスドライバーのアンインストール方法
 */
import { Step } from "../components/Step";
import startMenu from "./img/drv_install_11_1.png";
import deviceManager from "./img/drv_uninstall3.png";
import uninstallDriver from "./img/drv_uninstall4.png";
import confirmUninstall from "./img/drv_uninstall5.png";
import closeManager from "./img/drv_uninstall6.png";

/**
 *
 * @returns デバイスドライバーのアンインストール方法のJSX Element
 */
export const HowToUninstallDeviceDriver: React.FC = () => {
  return (
    <div>
      <h2 className="p-heading-2">デバイスドライバーのアンインストール方法</h2>
      <Step
        step="1"
        text="CMCD-200の電源が入っている状態で、CMCD-200をお客様のお持ちのパソコンとUSBケーブル(別売)で接続してください。
						（接続後にCMCD-200の電源を入れても大丈夫です。）"
      />

      <Step
        step="2"
        text="デバイスマネージャーを表示します。スタートボタンを右クリック(タッチパネルの場合は長押し)し、「デバイスマネージャー」をクリックします。"
        image={startMenu}
        alt="スタートメニュー"
      />

      <Step
        step="3"
        text="ポート(COMとLPT)をダブルクリックし、CMCD-200を右クリックします。"
        image={deviceManager}
        alt="デバイスマネージャー"
      />

      <Step
        step="4"
        text="デバイスのアンインストールをクリックします。"
        image={uninstallDriver}
        alt="デバイスのアンインストール"
      />

      <Step
        step="5"
        text="デバイスのアンインストール画面で、「このデバイスのドライバーを削除しようとしました。」にチェックを入れ、OKボタンをクリックします。"
        image={confirmUninstall}
        alt="デバイスのアンインストール画面"
      />

      <Step
        step="6"
        text="デバイスドライバーが削除されたことを確認し、デバイスマネージャーを閉じます。"
        image={closeManager}
        alt="デバイスマネージャーを閉じる"
      />
    </div>
  );
};
